import { render, staticRenderFns } from "./GarantiaPagada.vue?vue&type=template&id=5596d75d&"
import script from "./GarantiaPagada.vue?vue&type=script&lang=js&"
export * from "./GarantiaPagada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports